export const FILING_REPORT_STATUS_OPTIONS = [
    "POS pending",
    "NAR pending",
    "Unable to serve defendant",
    "Attorney pending to approve",
    "Ongoing negotiations",
    "Removing to Federal",
    "Waiting on conformed copies",
    "Stay action - in Arbitration",
    "Pending claimant approval",
    "Service by publication pending",
] as const;

export type FilingReportStatusOption = (typeof FILING_REPORT_STATUS_OPTIONS)[number];
